import {combineReducers} from 'redux'
import isResultReducer from "./isResultReducer"
import loginReducer from "./loginReducer"
//IndexImportHygen
const allLoginReducers = combineReducers({
    isResultReducer,
    loginReducer,
    //IndexUsingHygen
})

export default allLoginReducers;